module.exports = __webpack_public_path__ + "img/mastercard-securecode.55a7569d.png";